<script>
	import {
		Button
	} from 'element-ui';
	export default {
		extends: Button,
		props:{
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			index: {
				type: Number,
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {

			}
		},
		created() {


		},
		mounted() {
			if (this.store.box) {
				this.store.box[this.index] = this
			} else {
				let arr = []
				arr[0] = this
				this.store.box = arr
			}
		},
		watch: {

		},
		computed: {

		},
		methods: {

		}
	}
</script>
